
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["checkUserActivity","clearCartItem"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "03a207f83463b3ac7109.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			